import { render } from "./Currency.vue?vue&type=template&id=4a4c7249"
import script from "./Currency.vue?vue&type=script&lang=js"
export * from "./Currency.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.29.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__